import { addbook } from "../actions";

export default function addBook(bookInfo) {
  return async (dispatch) => {
    try {
      const response = await fetch("http://localhost:9000/books", {
        method: "POST",
        body: JSON.stringify(bookInfo),
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      });
      const book = await response.json();

      dispatch(addbook(book));
      
    } catch (error) {
      console.error(error);
    }
  };
}
